import React from 'react'
import type { InboxParticipant } from '../inboxTypes'
import { handleAvatarError } from '../utils'

interface ParticipantPillProps {
  participant: InboxParticipant
  isReviewAuthor: boolean
}

export const ParticipantPill: React.FC<ParticipantPillProps> = ({
  participant,
  isReviewAuthor
}) => (
  <div className='inbox-participant-pill'>
    <img
      className='inbox-participant-pill-avatar'
      src={participant.avatarUrl}
      alt=''
      onError={(event) => handleAvatarError(event.currentTarget)}
    />
    <span className='inbox-participant-pill-text'>
      <span className='inbox-participant-pill-name'>{participant.fullName}</span>
      {participant.orgName != null && participant.orgName !== '' && (
        <>
          <span className='inbox-participant-pill-comma'>, </span>
          <span className={isReviewAuthor ? 'inbox-participant-pill-org inbox-participant-pill-org--author' : 'inbox-participant-pill-org'}>
            {participant.orgName}
          </span>
        </>
      )}
    </span>
  </div>
)
